<template>
      <div>
            <!-- Submenu -->
            <client-submenu/>

            <!-- Wrapper -->
            <core-layout-content large>
                  <!-- Header with headline and actions -->
                  <div class="flex wrap xs-12 pt2 pb2 bg4">
                        <!-- Left -->
                        <div class="flex xs-6 md-6 xs-left xs-middle">
                              <h1 class="fs7 lh125 fw7 c1 mr4">{{ $t("logs") }}</h1>
                        </div>
                  </div>

                  <!-- Data Container -->
                  <j-card class="bg5">
                        <j-data-table :header="header" :list="events" :sortable="true" @sort="onSort($event)">
                              <template slot="list" slot-scope="{ item }">
                                    <td v-for="(column, i) in header" :key="i">{{ item[column.field] }}</td>
                              </template>
                              <template slot="empty">{{ $t("errors.no_data") }}</template>
                        </j-data-table>
                  </j-card>
            </core-layout-content>
      </div>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import ClientSubmenu from "../components/ClientSubmenu"
import CrmIcon from "@/components/CrmIcon/"
import JButton from "@/components/JButton/"
import JCard from "@/components/JCard/"
import JDataTable from "@/components/JDataTable/"
import JAvatar from "@/components/JAvatar/"
import JSearch from "@/components/JSearch/"
import JTabs from "@/components/JTabs/"
import JPagination from "@/components/JPagination/"
import { mapState, mapActions } from "vuex"
import dayjs from "dayjs"
import get from "lodash.get"
import api from "@/modules/clients/api/"

export default {
	components: {
		CoreLayoutContent,
		ClientSubmenu,
		CrmIcon,
		JButton,
		JCard,
		JDataTable,
		JAvatar,
		JSearch,
		JTabs,
		JPagination
	},

	data() {
		return {
			events: []
		}
	},

	props: {
		id: {
			type: String,
			required: true
		},
		clientType: {
			type: String,
			required: true,
			default: "individual"
		}
	},

	computed: {
		...mapState(["settings"]),

		header() {
			return [
				{
					text: this.$t("when"),
					field: "when",
					sortable: false
				},
				{
					text: this.$t("user"),
					field: "user",
					sortable: false
				},
				{
					text: this.$t("event"),
					field: "event",
					sortable: false
				}
			]
		}
	},

	methods: {
		async fetchEvents() {
			let apiKeys = null

			if (this.$route.params.clientType === "individual")
				apiKeys = {
					request: "individual",
					result: "individuals"
				}
			else apiKeys = { request: "company", result: "companies" }

			let where = { id: this.id }
			const res = await api[apiKeys.request]({ where })

			// Error
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
			}

			let events = res.data[apiKeys.result].list[0].events

			// Crunch events
			// Also reverse them so that most recent one is the most top
			this.events = events
				.map(item => ({
					when: item.timestamp
						? dayjs(item.timestamp).format(
								"DD/MM/YYYY HH:mm:ss"
						  )
						: null,
					user: get(item, "by.username"),
					event: this.$t(`logs_enums.${item.type}`)
				}))
				.reverse()
		}
	},

	created() {
		this.fetchEvents()
	}
}
</script>
